<template>
  <div>
    <v-app-bar color="#344452" dark class="app-bar">
      <v-spacer></v-spacer>
      <v-menu bottom open-on-hover offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="nav-right d-flex">
            <v-list-item v-bind="attrs" v-on="on" class="list-item">
              <v-list-item-content class="text-right">
                <v-list-item-subtitle
                  class="list-item-subtitle"
                >{{profile.firstName}} {{profile.lastName}}</v-list-item-subtitle>
                <v-list-item-title
                  v-if="profile.userType === 'super'"
                  class="list-item-title"
                >Super Admin</v-list-item-title>
                <v-list-item-title v-else class="list-item-title">Admin</v-list-item-title>
              </v-list-item-content>
              <v-avatar
                v-if="profile.media && profile.media.length && profile.media[0].url"
                size="60"
                class="ml-4 my-1"
              >
                <v-img :src="profile.media[0].url"></v-img>
              </v-avatar>
              <v-avatar v-else size="60" class="ml-4 my-1" color="#fff">
                <span
                  v-if="profile && profile.firstName"
                  class="profile-picture-name"
                >{{ profile.firstName.slice(0, 1) }}</span>
              </v-avatar>
            </v-list-item>
          </div>
        </template>
        <v-list>
          <v-list-item @click="myProfile">
            <v-list-item-icon>
              <img src="@/assets/images/Setting.svg" />
            </v-list-item-icon>
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <img src="@/assets/images/Signout.svg" />
            </v-list-item-icon>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <dashboard-info v-if="$route.name === 'dashboard'"></dashboard-info>
  </div>
</template>

<script>
import { UserService } from "@/services";
import { AuthService } from "@/services";

export default {
  components: {
    DashboardInfo: () => import("./DashboardInfo"),
  },
  data: () => ({
    newsFeed: null,
    channel: null,
    user: null,
    product: null,
    profile: Array,
  }),
  created() {
    this.initialize();
    this.$bus.$on('initializeHeader', () => {
      this.initialize();
    });
  },
  methods: {
    async initialize() {
      const profile = await UserService.profile();
      this.profile = profile.data;
    },
    async myProfile() {
      this.$router.push("/profile");
    },
    async logout() {
      const response = await AuthService.logout();
      if (response) {
        this.$store.dispatch("user/setToken", null);
        this.$store.dispatch("user/setUser", null);
        this.$router.push({ name: "login" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-picture-name {
  font-size: 3rem;
  font-weight: 600;
  color: #344452;
}
.app-bar {
  margin: 40px !important;
  border-radius: 4px !important;
  height: auto !important;
  padding: 12px 0px !important;
}
.list-item {
  width: min-content;
}
.list-item-subtitle {
  font-size: 16px;
  color: #fff;
}
.list-item-title {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
}
</style>